import dateFormat from 'dateformat';
import { MajorHistoryItem } from './types';

const formatHistoryDate = (value?: string | null) =>
  value ? dateFormat(new Date(value), 'dd/mm/yyyy, HH:MM') : '-';

const isValidatedRestitution = (test: MajorHistoryItem) =>
  Boolean(test.createdAt && test.updatedDate && test.consultantId);

const isRawResult = (test: MajorHistoryItem) => Boolean(test.updatedDate && !test.consultantId);

export const toHistoryDropdownItems = (testResults: MajorHistoryItem[]) => {
  const isPreferenceHistory = testResults.some(test => 'realizationDate' in test);

  const sortedResults = [...testResults].sort((a, b) => {
    if (!isPreferenceHistory) {
      return new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf();
    }

    const comparaison =
      new Date(b.realizationDate || 0).valueOf() - new Date(a.realizationDate || 0).valueOf();

    if (comparaison !== 0) {
      return comparaison;
    }

    return a.id - b.id;
  });

  return sortedResults.map(test => ({
    id: test.id,
    label: `${formatHistoryDate(isPreferenceHistory ? test.realizationDate : test.createdAt)}${
      isValidatedRestitution(test) ? ' 🎓' : ''
    }`,
    italic: isRawResult(test),
  }));
};
